// extracted by mini-css-extract-plugin
export default {"buttons":"ButtonSection_buttons__GRhdg","buttons__skip_btn":"ButtonSection_buttons__skip_btn__G-DaQ"};